import { ReactQueryProviderConfig } from "react-query";

export const queryConfig: ReactQueryProviderConfig = {
  refetchAllOnWindowFocus: false,
  refetchOnWindowFocus: false,
  retry: false,
};
